import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { GradingSchemaActionType } from '../actionTypes/gradingSchemas';
import { GradingSchemaBase, PostDispatch } from '../types';

export const getGradingSchemas =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get('/gradingSchema');
        dispatch({
            type: GradingSchemaActionType.GET_GRADING_SCHEMAS,
            payload: response.data,
        });
    };

export const createGradingSchema =
    (gradingSchema: GradingSchemaBase) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post('/gradingSchema', gradingSchema);
        dispatch({
            type: GradingSchemaActionType.CREATE_GRADING_SCHEMA,
            payload: response.data,
        });
    };

export const updateGradingSchema =
    (gradingSchema: GradingSchemaBase) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(
            `/gradingSchema/${gradingSchema._id}`,
            gradingSchema
        );
        dispatch({
            type: GradingSchemaActionType.UPDATE_GRADING_SCHEMA,
            payload: response.data,
        });
    };

export const deleteGradingSchema =
    (gradingSchemaId: string) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.delete(
            `/gradingSchema/${gradingSchemaId}`
        );
        dispatch({
            type: GradingSchemaActionType.DELETE_GRADING_SCHEMA,
            payload: response.data,
        });
    };
